import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import styled from 'styled-components';

const Styles = styled.div`   
.breadcrumb-bg { 
    background-color:#e9ecef;
}

`;


const NoMatch = () => {

    return (
        <Styles>
            <div className="row breadcrumb-bg">
                <div className="container">
                    <Breadcrumb>
                        <Breadcrumb.Item href="https://www.ttsh.com.sg/Pages/default.aspx"><small>Home</small></Breadcrumb.Item>
                        <Breadcrumb.Item href="/"><small>Visitor Facilitation</small></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>

            <div className="container">
                <br />
                <div className="content-message">
                    <div clas="container">
                        <div class="row justify-content-center">
                            <h1>Page Not Found!</h1>
                        </div>
                    </div>
                </div>

                <hr className="animate__animated animate__bounceIn animate__delay-1s" />

                <br />
                <br />
                <br />
                <br />
            </div>
        </Styles>
    );
};
 
 export default NoMatch;